module.exports = __webpack_public_path__ + "37e50345551fd9ff2a6e3367e0eb1d30.png";